const px = 1652 / 1012
const py = 2336 / 1414

export const S1_CC2206_Test_NT_210507 = {
  FRONT: {
    EXAM_GROUP_KEY: '05122006111',
    QR_INFO: {
      checkDigit: 9612,
      correctSize: { w: 1012 * px, h: 1414 * py },
      correctMarkers: {
        tl: { x: 28.5 * px, y: 28.5 * py },
        tr: { x: 982 * px, y: 28.5 * py },
        bl: { x: 28.5 * px, y: 1390 * py },
        br: { x: 982 * px, y: 1390 * py }
      },
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: null,
      numCheckPosition: {
        l: 751 * px,
        t: 311 * py,
        w: 73 * px,
        h: 28 * py
      },
      clipScale: 0.8,
      isHorizontal: false,
    }
  },
} as const
